import React from 'react'
import useSWR from 'swr'
import shallow from 'zustand/shallow'

import { WaitingForInstantDataContent } from '@frame/ui-components/waiting-for-instant-data-content'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'

import { ClientSessionState } from '@frame/lib/api/client-session/types'
import { useRootContext } from '@frame/lib/context'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { useStore } from '@frame/lib/stores/useStore'
import { DataAttribute } from '@frame/types'

const MIN_WAIT_TIME = 2000

export function FakeWaitingForInstantData() {
  const { autoNavigate } = useAutoNavigate()
  const { actions } = useRootContext()
  const { hasExternalTasks, sessionState, usePOSFlow } = useStore(
    (state) => ({
      hasExternalTasks: state.session?.tasks.some((e) => e.is_external_employment),
      sessionState: state.session?.state,
      usePOSFlow: state.session?.max_employments && state.session?.max_employments > 1,
    }),
    shallow
  )
  const consentCall = hasExternalTasks && sessionState === ClientSessionState.CONSENT && usePOSFlow

  useSWR(['consent', consentCall], async () => {
    if (consentCall) {
      await new Promise((resolve) => {
        setTimeout(() => {
          if (consentCall) {
            resolve(true)
          }
        }, MIN_WAIT_TIME)
      })
      await actions.gatherSessionConsent()
      autoNavigate()
      return
    }
    return null
  })

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding backButton={{ visible: false }} />
      <Body data-cy={DataAttribute.SCREEN_WAITING_FOR_INSTANT_DATA} className="h-full p-5">
        <WaitingForInstantDataContent />
      </Body>
    </>
  )
}
